(function($) {
  function ReadMore() {
    $(document).on('click', '.readmore', function(e) {
      e.preventDefault();
      
      $('.product-description-short').addClass('hide');
      $('.product-description-full').removeAttr('hidden').removeClass('hide');
    });
    
    $(document).on('click', '.readless', function(e) {
      e.preventDefault();
      
      $('.product-description-short').removeClass('hide');
      $('.product-description-full').addClass('hide');
    });    
  }
  
  $(document).ready(function() {
    ReadMore();
  });
})(jQuery);